export function publicModelIDsV113(config = {}) {
  const policy = config.public_model_ids_v113;
  return {
    strip_vendor_prefix: policy?.strip_vendor_prefix === true,
    strip_free_suffix:
      policy === undefined
        ? config.model_sync_v103?.strip_free_suffix === true
        : policy?.strip_free_suffix === true,
  };
}

export function publicModelConfigV113(config = {}) {
  return {
    ...config,
    public_model_ids_v113: publicModelIDsV113(config),
    ...(config.model_sync_v103
      ? {
          model_sync_v103: {
            ...config.model_sync_v103,
            strip_free_suffix: false,
          },
        }
      : {}),
  };
}
